<template>
  <div class="page-wrapper">
    <InnerHeader />
    <main style="min-height: 73.7vh;">
      <router-view></router-view>
    </main>
    <SubFooterInner  style="min-height: 20vh;" v-show="is_subscribed == 'N'" />
    <MainFooter  />
  </div>
</template>

<script>
import InnerHeader from "@/components/InnerHeader";
import MainFooter from "@/components/MainFooter";
import SubFooterInner from "@/components/SubFooterInner.vue";

export default {
  name: "MainView",
  components: {
    MainFooter,
    InnerHeader,
    SubFooterInner,
  },
  data() {
    return {
      is_subscribed: "",
    };
  },
  computed: {},
  mounted() {
    this.is_subscribed = localStorage.getItem("is_membership_subscribed");
    this.moveToContacat();
  },
  methods: {
    moveToContacat() {
      window.scrollTo(0, 0);
    },
  },
};
</script>
